import { IGroupClientData } from '../../../game-server/src/modules/group/Group';
import { SET_GROUP_DATA } from './types';

export const setGroupData = (groupData: IGroupClientData) => {
	return {
		type: SET_GROUP_DATA,
		payload: groupData,
	};
};
